/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable fp/no-mutation */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import merge from 'lodash.merge';
import { commonMessages } from '../messages/common';
import { providerComparisonTableMessages } from '../messages/provider-comparison-table';
export const ProviderComparisonTableTranslations = merge(undefined, commonMessages, providerComparisonTableMessages);
